import { createEnv } from "@t3-oss/env-core";
import { z } from "zod";

export const env = createEnv({
	clientPrefix: "VITE_",

	client: {
		// Core URLs
		VITE_API_BASE_URL: z.string().min(1),
		VITE_WEB_SERVICE_URL: z.string().optional(),
		VITE_WEB_SERVICE_HOST: z.string().optional(),
		VITE_BASE_SERVICE_URL_CHINA: z.string().optional(),

		// Auth
		VITE_GOOGLE_CLIENT_ID: z.string().optional(),
		VITE_FACEBOOK_APP_ID: z.string().optional(),
		VITE_APPLE_CLIENT_ID: z.string().optional(),

		// Analytics
		VITE_GA_MEASUREMENT_ID: z.string().optional(),

		// Metabase
		VITE_METABASE_API_KEY: z.string().optional(),

		// Zendesk
		VITE_ZENDESK_IS_VISIBLE: z.string().optional(),
		VITE_ZENDESK_URL: z.string().optional(),

		// Intercom (fallback)
		VITE_INTERCOM_APP_ID: z.string().optional(),

		// Sentry
		VITE_SENTRY_DSN: z.string().optional(),
		VITE_DEPLOYMENT_ENVIRONMENT: z.string().optional(),

		// Firebase
		VITE_FIREBASE_PROJECT_ID: z.string().optional(),

		// Stripe
		VITE_STRIPE_API_KEY: z.string().optional(),

		// Weglot
		VITE_WEGLOT_API_KEY: z.string().optional(),

		// Image Assets
		VITE_IMAGE_ASSETS_URL: z.string().optional(),
		VITE_IMAGE_STATIC_ASSETS_URL: z.string().optional(),

		// reCAPTCHA
		VITE_RECAPTCHA_SITE_KEY: z.string().optional(),

		// PostHog
		VITE_POSTHOG_API_KEY: z.string().optional(),
		VITE_POSTHOG_HOST: z.string().optional(),

		// Freshdesk
		VITE_FRESHDESK_API_KEY: z.string().optional(),

		// CometChat
		VITE_COMET_CHAT_AUTH_KEY: z.string().optional(),

		// Radar
		VITE_RADAR_URL: z.string().optional(),

		// App identification (for China vs Global)
		VITE_APP_NAME: z.string().optional(),

		// Login URL (optional override)
		VITE_LOGIN_URL: z.string().optional(),

		// SmartCat Translation
		VITE_IS_SMARTCAT_ENABLED: z.string().optional(),

		// Mapbox — the turning globe on the /partner landing page.
		//
		// ⚠️  OPTIONAL, AND IT HAS TO STAY OPTIONAL. A required var here throws at
		// import time wherever it is unset, which would take the whole app down
		// over one decorative card. Undefined is a valid outcome: the globe falls
		// back to the drawn inventory panel the design already specifies. Staging
		// and production need it set, or that card silently shows the fallback.
		VITE_MAPBOX_ACCESS_TOKEN: z.string().optional(),
	},

	runtimeEnv: import.meta.env,
	emptyStringAsUndefined: true,
});
